<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>回访统计</span>
          </div>
          <el-form
            :model="searchData">
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label-width="120px"
                  label="客户编码：">
                  <el-input
                    v-model.trim="searchData.id"
                    class="jm-input175"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="100px"
                  label="回访创建人：">
                  <el-select
                    v-model="searchData.adminuid"
                    filterable
                    class="jm-input135"
                    clearable
                    placeholder="请选择">
                    <el-option-group
                      v-for="(group, k) in ds.create_person"
                      :key="k"
                      :label="k">
                      <el-option
                        v-for="item in group"
                        :key="item.userid"
                        :label="item.username"
                        :value="item.userid"/>
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="110px"
                  label="回访创建时间：">
                  <el-date-picker
                    :editable="false"
                    v-model="searchData.creationDate"
                    type="daterange"
                    unlink-panels
                    placeholder="选择日期"
                    class="jm-input280"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" v-if="$hasPermission([1, 62, 101])">
                <el-form-item
                  label-width="120px"
                  label="业务部门：">
                  <el-select
                    v-model="searchData.department"
                    class="jm-input220"
                    filterable
                    clearable
                    placeholder="请选择">
                    <el-option
                      v-for="item in ds.departments"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="100px"
                  label="回访类型：">
                  <jm-dict-select
                    class="jm-input135"
                    clearable
                    type="dataset"
                    v-model="searchData.visit_type"
                    dict-type="student"
                    name="visitType"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="110px"
                  label="回访方式：">
                  <jm-dict-select
                    clearable
                    class="jm-input220"
                    dict="dataset.visit.way"
                    v-model="searchData.visit_kind"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label-width="120px"
                  label="资源创建时间：">
                  <el-date-picker
                    :editable="false"
                    v-model="searchData.student_create_time"
                    type="daterange"
                    unlink-panels
                    placeholder="选择日期"
                    class="jm-input280"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="100px"
                  label="入学时间：">
                  <el-date-picker
                    :editable="false"
                    v-model="searchData.startSchoolDateYear"
                    @change="() => this.searchData.startSchoolDateMonth = ''"
                    type="year"
                    placeholder="请选择"
                    class="jm-input135"
                    format="yyyy"
                    value-format="yyyy"/>
                  <el-date-picker
                    :editable="false"
                    v-model="searchData.startSchoolDateMonth"
                    :disabled="!searchData.startSchoolDateYear"
                    type="month"
                    placeholder="请选择"
                    class="jm-input135"
                    popper-class="process-list-popper"
                    format="MM"
                    value-format="MM"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label-width="110px"
                  label="客户分级：">
                  <jm-dict-select
                    class="jm-input135"
                    clearable
                    type="dataset"
                    v-model="searchData.customerClassification"
                    dict-type="student"
                    name="customLvType"
                    :filter="(item) => $hasPermission([1, 80, 30, 77, 62, 89]) || item.value !== 66"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label-width="120px"
                  label="活动编码：">
                  <el-input
                    v-model="searchData.activity_code"
                    class="jm-input175"/>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  label-width="100px"
                  label="渠道来源：">
                  <jm-channel
                    v-model="searchData.channel"
                    clearable
                    filterable/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  label-width="120px"
                  label="咨询顾问：">
                  <el-select
                    v-model="searchData.crm_sayer"
                    class="jm-input135"
                    clearable
                    placeholder="请选择"
                    filterable>
                    <el-option-group
                      v-for="(group, k) in ds.advisory_teacher"
                      :key="k"
                      :label="k">
                      <el-option
                        v-for="item in group"
                        :key="`${item.country}_${item.userid}`"
                        :label="item.truename"
                        :value="item.userid"/>
                    </el-option-group>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="searchBottom">
                  <el-button
                    class="jm-input-common3"
                    type="primary"
                    @click="() => this.refresh = true">搜索</el-button>
                  <el-button
                    class="jm-input-common3"
                    type="default"
                    @click="resetFields">重置</el-button>
                  <el-button
                    class="jm-input-common3"
                    v-if="$hasPermission([1, 62, 99, 100])"
                    type="success"
                    :loading="exporting"
                    @click="exportVisit">导出数据</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <jm-tableList
            url="/index/visit/searchList"
            :search-data="searchData"
            :refresh.sync="refresh">
            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="custom_name">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.custom_name }} {{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="80"
              align="center">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{name:'editStudent', params: { id: scope.row.userid }}">
                  <el-button
                    type="primary"
                    size="small">查 看</el-button>
                </router-link>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect, } from '@/components/tool/index.js';
import { formatSelectGroupData } from '@/utils/utils.js';
import ElRow from 'element-ui/packages/row/src/row';
import { jmChannel } from '@/components/tool';
import student from './student';

export default {
  data() {
    return {
      searchData: {
        id: '',
        adminuid: '',
        creationDate: [],
        department: '',
        visit_type: '',
        visit_kind: '',
        student_create_time: [],
        startSchoolDateYear: '', // 入学日期
        startSchoolDateMonth: '', // 入学日期
        customerClassification: '', // 客户分级
        activity_code: '', // 活动编号
        // 渠道
        channel: {
          custom_from: '',
          custom_from_sub: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: ''
        },
        crm_sayer: '', // 咨询老师
      },
      refresh: false,
      ds: {},
      exporting: false,
    };
  },
  components: {
    ElRow,
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
    jmChannel,
  },
  computed: {
  },
  mixins: [student],
  methods: {
    /**
       * Description: 重置搜索条件
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    resetFields() {
      Object.keys(this.searchData).forEach((k) => {
        if (typeof this.searchData[k] !== 'object') {
          this.searchData[k] = '';
        }
      });
      this.searchData.channel.custom_from = '';
      this.searchData.creationDate = [];
      this.searchData.student_create_time = [];
      this.$store.commit('updateRefresh', true);
    },
    getDatasource() {
      this.$http._get({
        url: '/index/Visit/searchDs',
      }).then((response) => {
        this.ds = response.data;
        // 创建人
        this.ds.create_person = formatSelectGroupData(this.ds.create_person);
        // 咨询
        this.ds.advisory_teacher = this.formatTeacher(this.ds.advisory_teacher);
      });
    },
    exportVisit() {
      this.exporting = true;
      this.$http._post({
        url: '/index/visit/exportVisit',
        data: this.searchData,
      }).then(({ data }) => {
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: '回访记录.xlsx'
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }
        this.exporting = false;
      });
    },
  },
  mounted() {
    this.getDatasource();
  },
};
</script>
<style scoped>
</style>
